// +41 Switzerland, +49 Germany, +43 Austria
export const SUPPORTED_COUNTRY_PHONE_CODES = ['41', '49', '43'] as const;
export const MIN_CANDIDATE_PHONE_NUMBER_LENGTH = 9;
export const MAX_CANDIDATE_PHONE_NUMBER_LENGTH = 15;
export const MIN_CANDIDATE_FILTER_PHONE_NUMBER_LENGTH = 4;

/**
 * Mostly validates country code and a minimum length.
 * Avoiding a strict regex since it will also be checked by a 3rd party service.
 */
export const CANDIDATE_PHONE_NUMBER_REGEX = new RegExp(
  `^\\+?(?=(?:\\s*\\d){${MIN_CANDIDATE_PHONE_NUMBER_LENGTH},${MAX_CANDIDATE_PHONE_NUMBER_LENGTH}}$)(${SUPPORTED_COUNTRY_PHONE_CODES.join(
    '|',
  )})(?:\\s*\\d)*`,
);

export const CANDIDATE_ALTERNATIVE_PHONE_NUMBERS_REGEX = new RegExp(
  `^\\+?(?=(?:\\s*\\d){${MIN_CANDIDATE_PHONE_NUMBER_LENGTH},${MAX_CANDIDATE_PHONE_NUMBER_LENGTH}}$)\\d(?:\\s*\\d)*`,
);

export const CANDIDATE_FILTER_PHONE_NUMBER_REGEX = new RegExp(
  `^\\+?(?=(?:\\s*\\d){${MIN_CANDIDATE_FILTER_PHONE_NUMBER_LENGTH},${MAX_CANDIDATE_PHONE_NUMBER_LENGTH}}$)(${SUPPORTED_COUNTRY_PHONE_CODES.join('|')})?(?:\\s*\\d)*`,
);

export const E164_PHONE_NUMBER_REGEX = new RegExp('^\\+[1-9]\\d{8,14}$');
